import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { UserRole } from '../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** If set, only these roles can access. Operators not in the list are sent to /control-panel. */
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('adminToken');
  const { user } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const role = user?.role ?? 'operator';
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/control-panel" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
